export const listTypes = [
    {name: 'Buttons (Single-Select)', value: 'button-single'},
    {name: 'Buttons (Multi-Select)', value: 'button-multi'}, 
    {name: 'Radio Button', value: 'radio'},
    {name: 'Dropdown', value: 'dropdown'}, 
    {name: 'Check List', value: 'checklist'}
]